import React from 'react';
import PropTypes from 'prop-types';
import { renderIf } from 'common';

const FormInput = ({
    error,
    type = 'test',
    onChange,
    ...rest
}) => (
    <div className="spc--bottom--med">
        <input {...rest}
            type={type}
            className="input input--text input--med spc--bottom--tiny"
            onChange={(e) => onChange(e.target.name, e.target.value)} />
        { renderIf(error)(<p className="type--tiny type--color--error">{error}</p>)}
    </div>
)

FormInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['text', 'email', 'password']),
    error: PropTypes.string,
    placeholder: PropTypes.string,
};

export { FormInput }


// WEBPACK FOOTER //
// ./src/components/FormInput.js